export default {

  createColorTheme( hue ) {


    const

      maxHue  = this.randomInt(200, 360),
      minHue  = maxHue - 100,

      h1      = hue || this.randomInt(minHue, maxHue),
      sDark1  = this.randomInt(10, 60),
      // sLight1 = this.randomInt(70, 90),
      sLight1 = this.randomInt(80, 100),
      // lDark1  = this.randomInt(10, 20),
      lDark1  = this.randomInt( 5, 15),
      // lLight1 = this.randomInt(40, 50),
      lLight1 = this.randomInt(60, 90),

      h2      = h1 + 100,
      sDark2  = this.randomInt(10, 60),
      // sLight2 = this.randomInt(70, 90),
      sLight2 = this.randomInt(80, 100),
      // lDark2  = this.randomInt(10, 20),
      lDark2  = this.randomInt( 5, 15),
      // lLight2 = this.randomInt(40, 50),
      lLight2 = this.randomInt(60, 90),

      h3      = 360 - h1,
      sDark3  = this.randomInt(10, 60),
      sLight3 = this.randomInt(70, 90),
      lDark3  = this.randomInt(10, 20),
      lLight3 = this.randomInt(40, 50)

    return {
      dark1   : `hsl(${h1}, ${sDark1}%,  ${lDark1}%)`,
      light1  : `hsl(${h1}, ${sLight1}%, ${lLight1}%)`,
      dark2   : `hsl(${h2}, ${sDark2}%,  ${lDark2}%)`,
      light2  : `hsl(${h2}, ${sLight2}%, ${lLight2}%)`,
      dark3   : `hsl(${h3}, ${sDark3}%,  ${lDark3}%)`,
      light3  : `hsl(${h3}, ${sLight3}%, ${lLight3}%)`,
    }

  },

  randomColor() {
    const
      h = this.randomInt(0, 360),
      s = this.randomInt(40, 98),
      l = this.randomInt(40, 90)
    return `hsl(${h},${s}%,${l}%)`
  },

  randomInt: (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min
  },


}
